import { Plus } from 'lucide-react';

/**
 * The unmissable "add" — an accent circle bottom-right, clear of the tab bar and the iOS
 * home indicator.
 *
 * Usability testing 2026-08-01 (Faye): the dashed inline "Add something…" row was
 * effectively invisible — "really hard to see… took me a while" — and shopping mode's add
 * was a small glyph in the header. The inline rows stay (they're good once you know they
 * exist); this is the thing you find first.
 */
const PLACEMENT = {
  /** Inside the app shell: clear of the mobile tab bar, tucked lower on desktop. */
  page: 'bottom-[calc(72px+env(safe-area-inset-bottom))] lg:bottom-8 lg:right-8',
  /** Inside a full-screen overlay: clear of that overlay's own footer. */
  overlay: 'bottom-[calc(88px+env(safe-area-inset-bottom))]',
} as const;

export function Fab({
  label,
  onClick,
  testId,
  placement = 'page',
}: {
  label: string;
  onClick: () => void;
  testId: string;
  placement?: keyof typeof PLACEMENT;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      data-testid={testId}
      className={`fixed right-4 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-accent text-inverse-fg shadow-xl transition-transform duration-150 ease-app active:scale-95 ${PLACEMENT[placement]}`}
    >
      <Plus className="h-7 w-7" strokeWidth={2.5} aria-hidden="true" />
    </button>
  );
}
